import { useMutation } from '@tanstack/react-query';
import _ from 'lodash';

import useAPI from 'services/useAPI';
import createMutationRequest from 'utils/createMutationRequest';

/**
 * @description A hook to handle updating and deleting relations betrween resources
 * @param {Object} options
 * @param {Function} options.refetchFn - A function to refetch the query
 * @param {Function|Array} options.queryKey - The query key to refetch
 * @param {Function} options.onError - A function to handle errors
 * @returns {Object} { updateRelations: Function, deleteRelations: Function } both are mutations that takes a list of relation objects
 * @example
 * const { updateRelations, deleteRelations } = useRelations({
 *  refetchFn: assetsRelationQuery.refetch,
 * queryKey: org2assets.org(createRelationQueryData(ResourceType.Asset)),
 * onError: addErrorAlert
 * });
 */
const useRelations = ({ refetchFn, unusedQueryKey, onError }) => {
  const api = useAPI();

  const updateRelations = useMutation({
    mutationFn: createMutationRequest(api.core.createRelationship),
    onMutate: (relations) => {
      const relation = _.first(relations);
      // const key = _.isFunction(queryKey) ? queryKey(relation) : queryKey;
      // const oldData = queryClient.getQueryData(key);
      // queryClient.setQueryData(key, old => {
      //   if (!old) {
      //     return [relation];
      //   }
      //   return [...old, relation];
      // });
      // return { relation, oldData };
      return { relation };
    },
    onSuccess: () => {
      refetchFn();
    },
    onError: (error, variables, context) => {
      switch (error.response.status) {
        case 409:
          onError('Not possible to remove the last owner relation');
          return;
        default:
          break;
      }
      console.error(error);
      console.error('variables', variables);
      console.error('context', context);
      onError(error.message);
      refetchFn();
    }
  });

  const deleteRelations = useMutation({
    mutationFn: createMutationRequest(api.core.deleteRelationship),
    onSuccess: () => {
      refetchFn();
    },
    onError: (error, variables, context) => {
      switch (error.response.status) {
        case 409:
          onError('Not possible to remove the last owner relation');
          return;
        default:
          break;
      }
      console.error(error);
      console.error('variables', variables);
      console.error('context', context);
      onError(error.message);
      refetchFn();
    }
  });

  return (
    {
      updateRelations,
      deleteRelations
    }
  );
};

export default useRelations;
